// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import MPFamilyCardsContainer from '../containers/MPFamilyCardsContainer';
import MPFamilyInfoContainer from '../containers/MPFamilyInfoContainer';

const Wrapper = styled.div``;

const StyledMPFamilyInfoContainer = styled(MPFamilyInfoContainer)`
  margin-bottom: 0.3em;
`;

const StyledMPFamilyCardsContainer = styled(MPFamilyCardsContainer)`
  & > div {
    width: 54px;
  }
`;

type MPFamilyProps = {
  className?: string;
  onClick?: () => void;
};

const MPFamily = ({ className = '', onClick }: MPFamilyProps) => {
  return (
    <Wrapper className={className} onClick={onClick}>
      <StyledMPFamilyInfoContainer />
      <StyledMPFamilyCardsContainer />
    </Wrapper>
  );
};

export default MPFamily;
